<template>
  <div
    :class="['operator-btn-container', showAddImg ? 'show-dis-count-tag' : '']"
  >
    <shadow-mask v-if="showShadow" />
    <arrive-notice
      v-if="soldOut"
      :use-icon="useArrivedNoticeIcon"
      :has-subscribed="hasSubscribedArrivedNotice"
      :goods-status="statusRemindInfo.goods_status"
      :add-step-type="btnType"
      :use-red-add-cart="useRedAddCart"
      @subscribe="subscribe"
    />
    <simple
      v-else-if="useSimple"
      :show-count="showSimpleCount"
      :can-buy="canBuy"
      :count="count"
      :show-add-img="showAddImg"
      @add="add"
    />

    <activity
      v-else-if="useActivity"
      :count="count"
      :activity-info="activityInfo"
      :btn-style="btnStyle"
      :show-count="showSimpleCount"
      :has-set-remind="hasSetRemind"
      :available-amount="acitivityAvailableAmount"
      :use-icon="useIcon"
      @sub="sub"
      @keyboard="input"
      @add="add"
      @seckillRemind="seckillRemind"
    />

    <new-activity
      v-else-if="useNewActivity"
      :count="count"
      :activity-info="activityInfo"
      :has-set-remind="hasSetRemind"
      :available-amount="acitivityAvailableAmount"
      :limit-text="limitText"
      :is-promote="isPromote"
      @sub="sub"
      @keyboard="input"
      @add="add"
      @seckillRemind="seckillRemind"
    />

    <red-add-cart
      v-else-if="useRedAddCart"
      :promote-style="promoteStyle"
      :can-buy="canBuy"
      :count="count"
      :status-remind-info="statusRemindInfo"
      :use-icon="useIcon"
      :btn-width="btnWidth"
      :compact="redAddCartCompact"
      :add-step-type="btnType"
      :text="btnText"
      :icon-color="iconColor || ''"
      :bg-start-color="bgStartColor || THEME_START_COLOR"
      :bg-end-color="bgEndColor || THEME_COLOR"
      @sub="sub"
      @keyboard="input"
      @add="add"
    />

    <complex
      v-else-if="useComplex"
      :can-buy="canBuy"
      :count="count"
      :status-remind-info="statusRemindInfo"
      :use-icon="useIcon"
      :btn-width="btnWidth"
      :add-step-type="btnType"
      :text="btnText"
      :icon-color="iconColor || ''"
      :bg-start-color="bgStartColor || THEME_START_COLOR"
      :bg-end-color="bgEndColor || THEME_COLOR"
      @sub="sub"
      @keyboard="input"
      @add="add"
    />

    <can-not-buy
      v-else
      :goods-status="statusRemindInfo.goods_status"
      :status-show-name="statusRemindInfo.status_show_name"
      :no-buy-time-show="statusRemindInfo.no_buy_time_show"
      :open-remind="statusRemindInfo.open_remind"
      :add-step-type="btnType"
      :show-can-not-buy="showCanNotBuy"
    />
  </div>
</template>

<script>
import ShadowMask from './atoms/shadow'
import Simple from './atoms/simple'
import Complex from './atoms/complex'
import Activity from './atoms/activity'
import newActivity from './atoms/newActivity.vue'
import ArriveNotice from './atoms/arrive_notice'
import RedAddCart from './atoms/redAddCart.vue'
import CanNotBuy from './atoms/can_not_buy'
import { cart } from '@/utils/cart/index'
import { userInfo } from '@/utils/user'
import { API } from '@/api'
import { $numberKeyboard } from '@/common/widgets/number_keyboard'
import { miniProgramEnv } from '../../../defines/environment'
import { mpsCombination } from '../../../utils/native_interactions/mps_combination'
import { THEME_COLOR, THEME_START_COLOR } from '@/defines/environment/config'
export default {
  name: 'Operator',
  components: {
    Simple,
    Complex,
    ArriveNotice,
    CanNotBuy,
    Activity,
    newActivity,
    RedAddCart,
    ShadowMask
  },
  props: {
    ssu: {
      type: Object,
      default: () => ({})
    },
    computedSSu: {
      type: Object,
      default: null
    },
    useSimple: {
      type: Boolean,
      default: false
    },
    useActivity: {
      type: Boolean,
      default: false
    },
    useNewActivity: {
      type: Boolean,
      default: false
    },
    useRedAddCart: {
      type: Boolean,
      default: false
    },
    redAddCartCompact: {
      type: Boolean,
      default: false
    },
    isPromote: {
      type: Boolean,
      default: false
    },
    showSimpleCount: {
      type: Boolean,
      default: false
    },
    useArrivedNoticeIcon: {
      type: Boolean,
      default: false
    },
    showPromoteTip: {
      type: Boolean,
      default: false
    },
    btnStyle: {
      type: Object,
      default: () => {}
    },
    activityInfo: {
      type: Object,
      default: () => {}
    },
    showShadow: {
      type: Boolean,
      default: true
    },
    useIcon: {
      type: Boolean,
      default: true
    },
    btnWidth: {
      type: [Number, String],
      default: 0.52
    },
    btnText: {
      type: String,
      default: ''
    },
    btnType: {
      type: String,
      default: 'normal'
    },
    showCanNotBuy: {
      type: Boolean,
      default: true
    },
    bgStartColor: {
      type: String,
      default: ''
    },
    bgEndColor: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: ''
    },
    showAddImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cartSsu: {},
      count: 0,
      addStatus: false,
      hasSetRemind: false, // 是否设置过即将开抢提醒(针对秒杀)
      THEME_COLOR,
      THEME_START_COLOR
    }
  },
  computed: {
    promoteStyle() {
      return !!this.ssuInfo?.promotion?.promoteStyle
    },
    useComplex() {
      if (userInfo.isMemberMall) return true

      return (
        // eslint-disable-next-line eqeqeq
        this.statusRemindInfo.goods_status == 1 ||
        // eslint-disable-next-line eqeqeq
        this.statusRemindInfo.goods_status == 102
      )
    },
    ssuInfo() {
      return this.computedSSu ? this.computedSSu : this.ssu.ssuList[0]
    },
    uniqueId() {
      return this.ssuInfo.unique_id || this.ssuInfo.ssuId
    },
    hasPromote() {
      // eslint-disable-next-line camelcase
      const promoteType =
        this.ssuInfo?.promotion_remind_info?.promote_type ?? []
      return (
        promoteType.includes(2) || // 普通商品2和购物车3是一个东西
        promoteType.includes(3) ||
        promoteType.includes(4) ||
        promoteType.includes(21) || // 会员价（标签展示），新增类型
        promoteType.includes(12) // 会员 目前不再使用
      )
    },
    statusRemindInfo() {
      // eslint-disable-next-line camelcase
      const fromGood = this.ssuInfo?.status_remind_info
      // eslint-disable-next-line camelcase
      const fromCart = this.cartSsu?.statusRemindInfo
      const fromGoodExistAndParticipate =
        fromGood &&
        Number(fromGood.goods_status) === 8 &&
        Object.keys(fromGood).length > 0

      const fromCartExist = fromCart && Object.keys(fromCart).length > 0

      // 针对秒杀特殊处理
      // 已参与状态，通过购物车加购时，会拿到购物车的可加购状态，从而导致展示错误
      if (
        (this.useActivity || this.useNewActivity) &&
        fromGoodExistAndParticipate
      ) {
        return fromGood || {}
      } else if (fromCartExist) {
        return fromCart || {}
      } else {
        return fromGood || {}
      }
    },
    acitivityAvailableAmount() {
      const fromGood = this.ssuInfo?.status_remind_info?.remain_count
      const fromGoodNum = this.ssuInfo?.status_remind_info?.remain_count
      // eslint-disable-next-line camelcase
      const fromCart = this.cartSsu?.statusRemindInfo
      const fromCartNum = this.cartSsu?.statusRemindInfo?.available_amount

      const fromGoodExistAndParticipate =
        fromGood &&
        Number(fromGood.goods_status) === 8 &&
        Object.keys(fromGood).length > 0

      const fromCartExist = fromCart && Object.keys(fromCart).length > 0

      // 针对秒杀特殊处理
      // 已参与状态，通过购物车加购时，会拿到购物车的可加购状态，从而导致展示错误
      if (
        (this.useActivity || this.useNewActivity) &&
        fromGoodExistAndParticipate
      ) {
        return fromGoodNum || 0
      } else if (fromCartExist) {
        return fromCartNum || 0
      } else {
        return fromGoodNum
      }
    },
    promotionRemindInfo() {
      // eslint-disable-next-line camelcase
      const fromGood = this.ssuInfo?.promotion_remind_info
      // eslint-disable-next-line camelcase
      const fromCart = this.cartSsu?.promotionRemindInfo
      if (fromCart === undefined) {
        return fromGood
      } else {
        return fromCart
      }
    },
    soldOut() {
      if (userInfo.isMemberMall) return false
      // 只有当商品库存为0，也就是stock_num为0，或者goods_status=3(已售罄)时才展示到货提醒
      const { goods_status: status } = this.statusRemindInfo || {}
      const stockNum =
        // eslint-disable-next-line camelcase
        this.ssuInfo?.stock_num || this.ssuInfo?.stock_num || undefined
      return status === 3 || (stockNum && stockNum <= 0)
    },
    canBuy() {
      if (userInfo.isMemberMall) return true
      const { goods_status: status } = this.statusRemindInfo
      return !this.soldOut && (status === 1 || status === 102)
    },
    hasSubscribedArrivedNotice() {
      return !!this.cartSsu.hasSubscribed
    },
    promoteTip() {
      const promotionGoodsNum =
        // eslint-disable-next-line camelcase
        this.promotionRemindInfo?.promotion_goods_num || 0
      const count = this.count - promotionGoodsNum
      if (this.hasPromote && promotionGoodsNum > 0 && count > 0) {
        // eslint-disable-next-line camelcase
        return this.promotionRemindInfo?.contain_normal_goods_remind
          ? this.promotionRemindInfo.contain_normal_goods_remind.replace(
              '##PARAM##',
              count
            )
          : `包含${count}件原价商品`
      } else {
        return ''
      }
    },
    limitText() {
      return this.isPromote
        ? `促销限${this.ssuInfo?.promote_can_buy_num}件`
        : `秒杀限${this.ssuInfo?.status_remind_info?.available_amount}件`
    }
  },
  async created() {
    if (userInfo.isMemberMall) return
    this.cartSsu = cart.getByUniqueId(this.uniqueId, {
      // eslint-disable-next-line camelcase
      hasSubscribed: this.ssuInfo?.status_remind_info?.arrived_notice_status
    })
    this.count = this.cartSsu.count
    this._cart_ssu_subscribe_id = this.cartSsu.subscribe(good => {
      if (!this.addStatus) {
        this.cartSsu = good
        this.count = good.count
      }
    })

    // 判断当前商品是否设置过提醒(秒杀,即将开始)
    if (this.activityInfo?.status === 0 || this.activityInfo?.status === 3) {
      this.judgeHasRemind({ noClick: true })
    }
  },
  beforeDestroy() {
    this._cart_ssu_subscribe_id &&
      this.cartSsu.unsubscribe(this._cart_ssu_subscribe_id)
  },
  methods: {
    async add() {
      if (userInfo.isMemberMall) {
        this.$emit('goDetail')
        return
      }
      if (this.canBuy) {
        const original = this.count
        // 针对秒杀做促销商品数量限制弹窗处理
        const canBuy = this.seckillHandler(this.count)
        if (!canBuy) return

        try {
          if (this.count <= 998) {
            const isSendShopping = this.count === 0
            this.count += 1
            this.addStatus = true
            // 数量0 => 1需要调采购清单加入接口
            if (isSendShopping) {
              API.purchaseList.addShopping({
                action: 100,
                items: [
                  {
                    skuId: this.ssuInfo?.sku_id || 0,
                    ssuId: this.ssuInfo?.ssuId || 0,
                    biId: this.ssuInfo?.bi_id || 0,
                    class1Id: this.ssuInfo?.class1Id || 0
                  }
                ]
              })
            }
            const totalPrice = this.ssuInfo?.ssuPrice?.totalPrice || ''
            const res = await cart.debounceAdd(this.uniqueId, totalPrice)

            const newval = res.light_cart_ssus[0]
            if (newval?.status_remind_info?.goods_status === 9) {
              this.$toast(newval?.status_remind_info?.no_buy_time_remind)
            }
            this.addStatus = false
            this.$emit('add', this.ssu)
            if (miniProgramEnv.isMiniProgram) {
              mpsCombination.postMessage({
                data: {
                  type: 'addCart'
                }
              })
            }
          } else {
            this.$toast('购买不能大于999件')
          }
        } catch (error) {
          this.addStatus = false
          this.count = original
        }
      }
    },
    async sub() {
      if (userInfo.isMemberMall) {
        this.$emit('goDetail')
        return
      }
      this.count >= 1 && (this.count -= 1)
      const totalPrice = this.ssuInfo?.ssuPrice?.totalPrice || ''
      await cart.debounceSubtract(this.uniqueId, totalPrice)
      this.$emit('subtract', this.ssu)
      mpsCombination.postMessage({
        data: {
          type: 'addCart'
        }
      })
    },
    async input() {
      if (userInfo.isMemberMall) {
        this.$emit('goDetail')
        return
      }
      this.$emit('keyboard-open')
      try {
        const num = await $numberKeyboard(this.count)
        this.count = num
        const totalPrice = this.ssuInfo?.ssuPrice?.totalPrice || ''
        await cart.put({
          ssu_list: [
            {
              unique_id: this.uniqueId,
              num,
              put_goods_price: totalPrice
            }
          ]
        })
        this.$emit('add', this.ssu)
      } catch (e) {
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          this.$toast(msg)
        }
      } finally {
        this.$emit('keyboard-close')
      }
    },
    async subscribe() {
      try {
        const data = await cart.subscribe(this.uniqueId)
        const msg = typeof data === 'string' ? data : data.msg
        this.$toast(msg)
        this.$emit('subscribe', this.ssu)
      } catch (e) {
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          this.$toast(msg)
        }
      }
    },
    // 秒杀活动处理
    seckillHandler(currentCount) {
      if (currentCount >= this.statusRemindInfo.available_amount) {
        this.$toast({
          message: this.statusRemindInfo.out_available_amount_remind
        })
        return false
      }
      // 针对促销限制优惠商品数量进行弹窗提示
      // 例如：第二件商品恢复原价
      if (
        this.hasPromote &&
        this.promotionRemindInfo.promotion_goods_num > 0 &&
        currentCount <= this.promotionRemindInfo.promotion_goods_num &&
        currentCount + 1 > this.promotionRemindInfo.promotion_goods_num
      ) {
        this.$toast({
          message: this.promotionRemindInfo.over_promotion_remind
        })
      }
      return true
    },
    // 秒杀即将开抢设置提醒
    async seckillRemind() {
      if (this.hasSetRemind) return
      const message = '设置成功，开抢前五分钟提醒'

      // eslint-disable-next-line camelcase
      const { ssu_id, activity_id, sbu_name } = this.ssu
      try {
        await API.cms.postSubscribe({
          ssu_id,
          activity_id,
          sbu_name
        })
        this.judgeHasRemind()
        // 埋点
        this.$track('2043.0', {
          ssu_id,
          // eslint-disable-next-line camelcase
          activity_id: activity_id ? activity_id + '' : ''
        })
        // 小程序订阅处理
        if (miniProgramEnv.isMiniProgram) {
          mpsCombination.postMessage({
            data: {
              type: 'addCart'
            }
          })
        }
        // 弹窗提示
        this.$toast({
          message,
          icon: 'success'
        })
      } catch (error) {
        this.$toast(error?.res?.error?.msg || '网络异常，请检查网络')
      }
    },
    // 判断秒杀商品是否已经设置过提醒
    judgeHasRemind({ noClick = false } = {}) {
      const startTime = this.activityInfo.startTime
      const storeKey =
        startTime.getTime() +
        '-' +
        this.ssu.ssu_id +
        (this.activityInfo.status === 3 ? '-t' : '')
      const localCache =
        JSON.parse(localStorage.getItem('seckill_good_remind')) || []

      // 针对初始化判断是否已经设置过提醒
      if (noClick) {
        localCache.includes(storeKey) && (this.hasSetRemind = true)
        return
      }

      // 如果从未设置提醒
      if (!localCache.includes(storeKey)) {
        localCache.push(storeKey)
        localStorage.setItem('seckill_good_remind', JSON.stringify(localCache))
        this.hasSetRemind = true
      } else if (new Date().getTime() >= startTime.getTime()) {
        // 已经设置过，但是过了提醒时间
        const removeIndex = localCache.indexOf(storeKey)
        localCache.splice(removeIndex, 1)
        localStorage.setItem('seckill_good_remind', JSON.stringify(localCache))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.operator-btn-container {
  position: relative;

  background-color: #fff;
  &.show-dis-count-tag {
    background-color: transparent;
  }
}
</style>
